import axios from '../../../libs/axios';
export const register = data => {
  return axios.post('/auth/register', data);
};